import { RESET_STATE } from 'store/global/actions';

import { CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {
  list: { data: [], isLoading: false, hasError: false },
  mutation: { isSaving: false, errorMessage: null },
};

const upsertCriteria = (criteria, saved) => {
  const exists = criteria.some(item => item.criteriaId === saved.criteriaId);

  return exists
    ? criteria.map(item => (item.criteriaId === saved.criteriaId ? saved : item))
    : [...criteria, saved];
};

const criteriaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CRITERIA_ACTION_TYPE.SET_CRITERIA_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: payload,
          hasError: payload ? false : state.list.hasError,
        },
      };

    case CRITERIA_ACTION_TYPE.SET_CRITERIA_ERROR:
      return { ...state, list: { ...state.list, isLoading: false, hasError: true } };

    case CRITERIA_ACTION_TYPE.GET_MARGIN_CRITERIA:
      return { ...state, list: { data: payload ?? [], isLoading: false, hasError: false } };

    case CRITERIA_ACTION_TYPE.SET_CRITERIA_SAVING:
      return { ...state, mutation: { isSaving: payload, errorMessage: null } };

    case CRITERIA_ACTION_TYPE.SET_CRITERIA_SAVE_ERROR:
      return { ...state, mutation: { isSaving: false, errorMessage: payload ?? null } };

    case CRITERIA_ACTION_TYPE.CLEAR_CRITERIA_SAVE_ERROR:
      return { ...state, mutation: { ...state.mutation, errorMessage: null } };

    case CRITERIA_ACTION_TYPE.UPSERT_CRITERIA:
      return {
        ...state,
        list: { ...state.list, data: upsertCriteria(state.list.data, payload.data) },
        mutation: { isSaving: false, errorMessage: null },
      };

    case CRITERIA_ACTION_TYPE.REMOVE_CRITERIA:
      return {
        ...state,
        list: {
          ...state.list,
          data: state.list.data.filter(item => item.criteriaId !== payload),
        },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default criteriaReducer;
